import { useState, useEffect } from 'react';
import axios from 'axios';
import { backendLinkComplaint } from '../../config';

const VAPID_PUBLIC_KEY =
  "BCYAHgqOqsV9gNF86MqQ5RuJNA45Da2Rwx2y_Ecqp4qBnhC9VPahJtd2cqlmpTIvE__4WSYpI46pfuIXD2eR8iE";

function getOrCreateDeviceId() {
  const key = 'push_device_id';
  let id = localStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(key, id);
  }
  return id;
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export async function sendSubscriptionToBackend(subscription) {
  try {
    const device_id = getOrCreateDeviceId();
    await axios.post(
      `${backendLinkComplaint}shared/push/subscribe/`,
      { ...subscription.toJSON(), device_id },
      { withCredentials: true }
    );
  } catch (error) {
    console.error('Error saving push subscription:', error);
  }
}

export const useNotifications = () => {
  const [subscription, setSubscription] = useState(null);
  const [permissionStatus, setPermissionStatus] = useState(
    'Notification' in window ? Notification.permission : 'unsupported'
  );

  useEffect(() => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    const init = async () => {
      try {
        const registration = await navigator.serviceWorker.ready;

        // Step 1: Always check for an existing subscription and sync it to backend.
        // This covers cases where the subscription was created but never reached the
        // backend, or the user manually enabled notifications in browser settings.
        // Step 1: Always check for an existing subscription and sync it to backend.
        // This covers cases where the subscription was created but never reached the
        // backend, or the user manually enabled notifications in browser settings.
        const existingSub = await registration.pushManager.getSubscription();
        if (existingSub) {
          setSubscription(existingSub);
          await sendSubscriptionToBackend(existingSub);
        }

        // Step 2: Always request permission on every app open.
        // If already granted this resolves immediately. If the user previously
        // denied but later enabled manually in browser settings, we'll catch it here.
        const result = await Notification.requestPermission();
        setPermissionStatus(result);

        // Step 3: If permission is granted but no subscription exists yet, create one.
        // This handles the case where the browser skipped the native popup and the
        // user manually enabled notifications in browser settings after a prior visit.
        if (result === 'granted' && !existingSub) {
          const newSub = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
          });
          setSubscription(newSub);
          await sendSubscriptionToBackend(newSub);
        }
      } catch (error) {
        console.error('Push notification initialization error:', error);
      }
    };

    init();
  }, []);

  return { subscription, permissionStatus };
};
